import styled from "styled-components";

const ImageHint = styled.div`
  position: absolute;
  z-index: 9004;
  left: 0.43rem;
  top: 0.53rem;
  background-color: white;
  padding: 0.25rem;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  text-align: center;

  img {
    margin: 0;
    width: 60px;
    height: 40px;
  }
`;

export default ImageHint;
